<div class="f-row custom-dialog" [formGroup]="otpForm">
  <div class="container d-justify-bw">
    <div class="verify-title">
      <div class="title">
        <h3 class="title-text">{{ content?.warningList[0]?.title }}</h3>
        <span class="sub-title">
          <!-- A verification code has been sent to your registered email -->
          {{ this.Message }}
          <span class="title-variable">{{ email }}</span></span>
      </div>
      <div class="close">
        <button mat-icon-button (click)="closeDialog()">
          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
    </div>

    <div class="f-col d-align-center verify-body">
      <div class="f-col app-input-100w">

        <div class="f-row phone-inputs otp-box-style">
          <mat-form-field class="phone-validate" [ngClass]="{
              'error-field': otpForm.get('digit1')?.hasError('incorrect')
            }">
            <input matInput formControlName="digit1" id="digit1" maxlength="1" (input)="moveFocus($event, 1)"
              (keypress)="allowOnlyDigits($event)" />
          </mat-form-field>

          <mat-form-field class="phone-validate" [ngClass]="{
              'error-field': otpForm.get('digit2')?.hasError('incorrect')
            }">
            <input matInput formControlName="digit2" id="digit2" maxlength="1" (input)="moveFocus($event, 2)"
              (keypress)="allowOnlyDigits($event)" />
          </mat-form-field>

          <mat-form-field class="phone-validate" [ngClass]="{
              'error-field': otpForm.get('digit3')?.hasError('incorrect')
            }">
            <input matInput formControlName="digit3" id="digit3" maxlength="1" (input)="moveFocus($event, 3)"
              (keypress)="allowOnlyDigits($event)" />
          </mat-form-field>

          <mat-form-field class="phone-validate" [ngClass]="{
              'error-field': otpForm.get('digit4')?.hasError('incorrect')
            }">
            <input matInput formControlName="digit4" id="digit4" maxlength="1" (input)="moveFocus($event, 4)"
              (keypress)="allowOnlyDigits($event)" />
          </mat-form-field>

          <mat-form-field class="phone-validate" [ngClass]="{
              'error-field': otpForm.get('digit5')?.hasError('incorrect')
            }">
            <input matInput formControlName="digit5" id="digit5" maxlength="1" (input)="moveFocus($event, 5)"
              (keypress)="allowOnlyDigits($event)" />
          </mat-form-field>

          <mat-form-field class="phone-validate" [ngClass]="{
              'error-field': otpForm.get('digit6')?.hasError('incorrect')
            }">
            <input matInput formControlName="digit6" id="digit6" maxlength="1" (input)="moveFocus($event, 6)"
              (keypress)="allowOnlyDigits($event)" />
          </mat-form-field>
        </div>


        <span class="sub-title p-top-6x" [ngStyle]="{ color: 'red' }" *ngIf="showErrorMsg">
          {{ showErrorMsg }}
        </span>

        <!-- Timer and attempts messages -->
        <div *ngIf="(showTimer || attemptsLeft > 0) && invalidPassAttemptsLeft > 0" class="text-center">
          <span class="sub-title" *ngIf="countdown !== '00:00'" [innerHTML]="">Resend code in
            <span class="title-variable">{{ countdown }}</span></span><br />
          <!-- <span class="sub-title">You have
            <span class="title-variable">{{ attemptsLeft }}</span> attempts
            left.</span> -->
        </div>

        @if (
        attemptsLeft > 0 &&
        !showTimer &&
        countdown === '00:00' &&
        invalidPassAttemptsLeft > 0
        ) {
        <div class="flex-item-center cursor-pointer">
          <span class="sub-title">
            <a (keydown.enter)="onResendCodeClick()" tabindex="0" role="button" (click)="onResendCodeClick()"
              [class.disabled]="attemptsLeft <= 0">
              {{ content?.['b2b.register.resendcode'] || 'Resend code' }}
            </a>
          </span>
        </div>
        }

        @if (attemptsLeft === 0 && !showTimer && hideErrorMsg) {
        <div class="text-center">
          <span class="sub-title p-top-6x text-danger">{{ content?.dictionary?.['b2b.register.exceededMaximumAttempts'] || 'You have exceeded the maximum number of attempts to resend code.' }}
          </span>
        </div>
        }
      </div>
    </div>

    <div class="f-col d-align-right verify-footer">
      <button mat-button class="button--primary-small" [class.disabled]="isVerifying" [disabled]="otpForm.invalid && invalidPassAttemptsLeft > 0 " [ngStyle]="{'background-color': otpForm.invalid && invalidPassAttemptsLeft > 0 ? 'gray' : '',color: otpForm.invalid && invalidPassAttemptsLeft > 0 ? 'white' : '',
          border: otpForm.invalid && invalidPassAttemptsLeft > 0 ? '1px solid white' : ''}"
        (click)=" invalidPassAttemptsLeft == 0 ? closeDialog() : onVerify() ">
        <mat-spinner *ngIf="isVerifying" diameter="20" class="button"></mat-spinner>
        {{ invalidPassAttemptsLeft == 0 ? "Close" : "Verify" }}
      </button>
    </div>
  </div>
</div>